import * as types from '../types';
const hideCompletionPane = exerciseId => ({
  exerciseId,
  type: types.HIDE_COMPLETION_PANE
});
export default hideCompletionPane;